<template>
  <div id="user_detail">
      <TemplateLayout>
        <!-- Page Heading -->
        <h1 class="h3 mb-2 text-gray-800"> <router-link to="/user" class="text-gray-800">บัญชีผู้ใช้งาน</router-link> / <b class="text-primary">แก้ไขบัญชีผู้ใช้งาน</b></h1>
        <p class="mb-4">ผู้ดูแลระบบสามารถแก้ไขบัญชีผู้ใช้งานให้กับเจ้าหน้าที่ในสำนักงาน เปลี่ยนแปลงสิทธิ์ และสามารถระงับการใช้งาน รวมถึงการเปลี่ยนรหัสผ่านแทนผู้ใช้งานได้</p>

        
        <form method="post" @submit.prevent="saveUpdateUser">
            <div class="card shadow mb-4">
                <div class="card-header py-3">
                
                    <h6 class="m-0 font-weight-bold text-primary">ระบุข้อมูลทั่วไป</h6>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-4 hide">
                            <label>คำนำหน้านาม</label>
                            <select name="title_id" v-model="title_id" class="form-control">
                                <option v-for="title in title_option" :key="title.title_id" :value="title.title_id">{{ title.title_name }}</option>
                            </select>
                        </div>
                        <div class="col-lg-8 hide"></div>
                        <div class="col-lg-4">
                            <label>ชื่อจริง</label>
                            <input name="first_name" required type="text" v-model="first_name" class="form-control"/>
                        </div>
                        <div class="col-lg-4">
                            <label>นามสกุล</label>
                            <input name="last_name" required type="text" v-model="last_name" class="form-control"/>
                        </div>
                        <div class="col-lg-4"></div>

                        <div class="col-lg-4">
                            <label>สิทธิ์การใช้งาน</label>
                            <router-link to="/privilege" class="float-right"><i class="fas fa-pen-alt fa-fw"></i>&nbsp;จัดการรายการ</router-link>
                            <select name="privilege_id" required v-model="privilege_id" class="form-control">
                                <option value="">กรุณาเลือก</option>
                                <option value="*">ผู้ดูแลระบบ (มองเห็นกล้องทั้งหมด)</option>
                                <option v-for="item in privilege_option" :key="item.privilege_id" :value="item.privilege_id">{{ item.privilege_name }}</option>
                            </select>
                        </div>

                        <div class="col-lg-4">
                            <label>ตำแหน่ง</label>
                            <router-link to="/position" class="float-right"><i class="fas fa-pen-alt fa-fw"></i>&nbsp;จัดการรายการ</router-link>
                            <select name="position_id" v-model="position_id" class="form-control">
                                <option value="">กรุณาเลือก</option>
                                <option v-for="item in position_option" :key="item.position_id" :value="item.position_id">{{ item.position_name }}</option>
                            </select>
                        </div>
                        
                        <div class="col-lg-4">
                            <label>แผนก</label>
                            <router-link to="/department" class="float-right"><i class="fas fa-pen-alt fa-fw"></i>&nbsp;จัดการรายการ</router-link>
                            <select name="department_id" v-model="department_id" class="form-control">
                                <option value="">กรุณาเลือก</option>
                                <option v-for="item in department_option" :key="item.department_id" :value="item.department_id">{{ item.department_name }}</option>
                            </select>
                        </div>
                        <div class="col-lg-4">
                            <label>อีเมล์</label>
                            <input name="email" required type="email" v-model="email" class="form-control"/>
                        </div>
                        <div class="col-lg-4 hide">
                            <label>เบอร์โทร</label>
                            <input name="mobile" type="text" v-model="mobile" class="form-control"/>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button id="btnSaveData" type="submit" class="btn btn-primary">
                        <i class="fas fa-save fa-fw"></i>
                        บันทึกข้อมูล
                    </button>
                </div>
            </div>
        </form>

        <form method="post" @submit.prevent="saveAccessUser">
            <div class="card shadow mb-4">
                <div class="card-header py-3">
                    <h6 class="m-0 font-weight-bold text-primary">ระบุชื่อผู้ใช้งานและรหัสผ่าน</h6>
                </div>
                <div class="card-body">
                    <div class="alert alert-primary mt-3 mb-0">
                        <div class="row">
                            <div class="col-lg-4">
                                <label>เบอร์โทรศัพท์มือถือ 10 หลัก</label>
                                <input name="username" maxlength="10" onkeypress="IsKeyNumber(event);" required type="text" v-model="mobile" placeholder="เบอร์โทร..." class="form-control" readonly />
                            </div>
                        </div>

                    </div>
                </div>
                <!-- <div class="card-footer">
                    <button id="btnSaveAccessData" type="submit" class="btn btn-primary">
                        <i class="fas fa-save fa-fw"></i>
                        บันทึกข้อมูล
                    </button>
                </div> -->
            </div>
        </form>

        <div class="card shadow mb-4">
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12 text-center">
                        <h3>สถานะ: &nbsp;&nbsp;<label :class="{ 'text-success' : active, 'text-warning' : !active}">{{ active == true ? 'เปิดใช้งาน' : 'ยกเลิกการใช้งาน' }}</label></h3>
                        
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 text-center">
                        <button type="button" class="btn btn-success btn-radius" v-if="!active" @click="activeUser(1);">
                            <i class="fas fa-user fa-fw"></i>
                            เปิดการใช้งานอีกครั้ง
                        </button>
                        <button type="button" class="btn btn-warning btn-radius" v-if="active" @click="activeUser(0);">
                            <i class="fas fa-user-slash fa-fw"></i>
                            ยกเลิกการใช้งาน
                        </button>
                        <button type="button" class="btn btn-danger btn-radius" id="btnDeleteUserAccount" @click="deleteUser();">
                            <i class="fas fa-user-times fa-fw"></i>
                            ลบบัญชีการใช้งาน
                        </button>
                    </div>
                </div>
            </div>
        </div>

      </TemplateLayout>
  </div>
</template>

<script>

import TemplateLayout from "@/components/layout/TemplateLayout.vue";
import { MasterService } from '@/services/master.service';
import { UsersService } from '@/services/users.service';
import { AlertService } from '@/services/alert.service';

export default {
  name: 'UserDetail',
  components: {
    TemplateLayout
  },
  data() {
     return {
        title_option: [],
        privilege_option: [],
        position_option: [],
        department_option: [],
        title_id: "",
        first_name: "",
        last_name: "",
        privilege_id: "",
        position_id: "",
        department_id: "",
        email: "",
        mobile: "",
        username: "",
        password: "",
        password_confirm: "",
        active: 0
      }
  },
  methods: {
      async bindSelectOption ()
      {
        this.title_option = await MasterService.getMasterList("title");
        this.privilege_option = await MasterService.getMasterList("privilege");
        this.position_option = await MasterService.getMasterList("position");
        this.department_option = await MasterService.getMasterList("department");
      },
      async bindUserDetail()
      {
        var user_id = this.$route.params.id;
        if(user_id){
            const respons = await UsersService.getUserDetail(user_id);
            this.title_id = respons.title_id;
            this.first_name = respons.first_name;
            this.last_name = respons.last_name;
            this.privilege_id = respons.privilege_id;
            this.position_id = respons.position_id;
            this.department_id = respons.department_id;
            this.email = respons.email;
            this.mobile = respons.mobile;
            this.username = respons.username;
            this.active = respons.active == "1" ? true : false;
        }
      },
      async saveUpdateUser()
      {
        if(AlertService.confirm(window.$("#btnSaveData"),"ยืนยันรายการ?")){
            AlertService.loading(true,"บันทึกรายการ");
            var data = {
                first_name: this.first_name,
                last_name: this.last_name,
                mobile: this.mobile,
                email: this.email,
                title_id: this.title_id,
                position: this.position_id,
                department: this.department_id,
                privilege: this.privilege_id
            };
            var user_id = this.$route.params.id;
            const respons = await UsersService.userUpdate(user_id,data);
            if(respons.status == 200){
                AlertService.success("บันทึกสำเร็จ");
            }else{
                AlertService.error(respons.message)
            }
            AlertService.loading(false);
            }
        return false;
      },
      async saveAccessUser (){
        if(AlertService.confirm(window.$("#btnSaveAccessData"),"ยืนยันรายการ?")){
            AlertService.loading(true,"บันทึกรายการ");
            var user_id = this.$route.params.id;
            const respons = await UsersService.userUpdateAccount(user_id,this.username,this.password,this.password_confirm);
            if(respons.status == 200){
                AlertService.success("บันทึกสำเร็จ");
            }else{
                AlertService.error(respons.message)
            }
            AlertService.loading(false);
        }
        return false;
      },
      async activeUser (status){
            var msg = (status == 1 ? "เปิดใช้งาน" : "ยกเลิกการใช้งาน");
            AlertService.loading(true, msg);
            var user_id = this.$route.params.id;
            const respons = await UsersService.userActive(user_id,status);
            if(respons.status == 200){
                AlertService.success(msg+"สำเร็จ");
                this.bindUserDetail();
            }else{
                AlertService.error(respons.message)
            }
            AlertService.loading(false);
      },
      async deleteUser (){
          if(AlertService.confirm(window.$("#btnDeleteUserAccount"),"ยืนยันลบบัญชีการใช้งาน?")){
            AlertService.loading(true, "ลบบัญชีการใช้งาน?");
            var user_id = this.$route.params.id;
            const respons = await UsersService.userDelete(user_id);
            if(respons.status == 200){
                AlertService.success("ลบบัญชีสำเร็จ");
                setTimeout(() => {
                    this.$router.push('/user');
                }, 400);
            }else{
                AlertService.error(respons.message)
            }
            AlertService.loading(false);
          }
      }
  },
  mounted() {
    this.bindSelectOption();
    this.bindUserDetail();
  },
}

</script>

<style>
    .btn-radius {
        border-radius: 10rem;
        margin-left: 1rem;
        margin-right: 1rem;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        box-shadow: 0 .15rem 1.75rem 0 rgba(58,59,69,.15)!important;
    }
</style>